import React, { useEffect, useState } from 'react';
import { sanitizeHtml } from '../../utils/Tools';
import { IState } from '../../redux/redux';
import { IFeeTrackingData, IInvoiceApiInfo } from './StoreTypes';
import StoreX, { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { IProjectInfo } from '../_Core/CoreTypes';
import Button from '../_Core/Button';
import { FormatDate, FormatMoney } from '../../utils/Tools';
import Icon, { IconType } from '../Icon/Icon';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { Selectable } from '../../utils/CommonTypes/CommonTypes';

interface IProps {
  state: IState;
}
interface ISearch {
  paid?: boolean;
  notPaid?: boolean;
  noInvoice?: boolean;
  text?: string[];
  school?: number[];
  category?: number[];
  entryType?: number[];
  team?:boolean;
}

const FeeTracking = (props: IProps) => {
  const [data, setData] = useState<IFeeTrackingData>();
  const [filteredEntries, setFilteredEntries] = useState<IProjectInfo[]>([]);
  const [invoicesByEntry, setInvoicesByEntry] = useState<Record<number, IInvoiceApiInfo[]>>({});
  const [invoicesByParticipant, setInvoicesByParticipant] = useState<Record<number, IInvoiceApiInfo[]>>({});
  const [search, setSearch] = useState<ISearch>({});
  const [searchablePoints, setSearchablePoints] = useState<Selectable[]>([]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (data) {
      let invoicesByProject: Record<number, IInvoiceApiInfo[]> = {};
      let invoicesByParticipant: Record<number, IInvoiceApiInfo[]> = {};

      data.invoices.forEach((invoice) => {
        invoice.Items.forEach((item) => {
          let entryId = item.ForProjectId;
          if (!invoicesByProject[entryId]) {
            invoicesByProject[entryId] = [];
          }
          invoicesByProject[entryId].push(invoice);

          let participantId = item.ForPersonId;
          if (!invoicesByParticipant[participantId]) {
            invoicesByParticipant[participantId] = [];
          }
          invoicesByParticipant[participantId].push(invoice);
        });
      });
      setInvoicesByEntry(invoicesByProject);
      setInvoicesByParticipant(invoicesByParticipant);

      let points: Selectable[] = [];

      //paid & not paid
      points.push({ value: 'paid', label: 'Paid' });
      points.push({ value: 'notPaid', label: 'Not Paid' });
      points.push({ value: 'noInvoice', label: 'No Invoice' });
      points.push({ value: 'team', label: 'Team Project' });

      //Entry Types
      let point = { value: '', label: 'Entry Type', options: [] };
      data.entryTypes.forEach((type) => {
        point.options.push({ value: `entryType|${type.id}`, label: `${type.name}` });
      });
      if (point.options.length > 0) points.push(point);

      //categories
      point = { value: '', label: 'Category', options: [] };
      data.categories.forEach((project) => {
        point.options.push({ value: `category|${project.id}`, label: `${project.name}` });
      });
      if (point.options.length > 0) points.push(point);

      //schools
      point = { value: '', label: 'School', options: [] };
      data.schools.forEach((school) => {
        point.options.push({ value: `school|${school.id}`, label: `${school.name}` });
      });
      if (point.options.length > 0) points.push(point);

      setSearchablePoints(points);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let projects = data.projects;

      if (data.feeByProject) {
        if (search.paid) {
          projects = projects.filter((p) => data.feeInfoDic[p.id]?.PaidInFull);
        }
        if (search.notPaid) {
          projects = projects.filter((p) => !data.feeInfoDic[p.id]?.PaidInFull);
        }
      } else{
        if (search.paid) {
          projects = projects.filter((p) => {
            let owners = data.participants[p.id] || [];
            return owners.some((owner) => !(data.feeInfoDic[owner.PersonId+"|"+p.id]?.PaidInFull)) ? false : true  ;
          });
        }
        if (search.notPaid) {
          projects = projects.filter((p) => {
            let owners = data.participants[p.id] || [];
            return owners.some((owner) => !(data.feeInfoDic[owner.PersonId+"|"+p.id]?.PaidInFull)) ? true : false;
          });
        }
      }

      if(search.team){
        projects = projects.filter((p) => {
          let owners = data.participants[p.id] || [];
          return owners?.length > 1;
        });
      }

      if (search.noInvoice) {
        projects = projects.filter((p) => !(invoicesByEntry[p.id] && invoicesByEntry[p.id].length > 0));
      }
      if (search.category && search.category.length > 0) {
        projects = projects.filter((p) => search.category.includes(p.categoryId));
      }
      if (search.school && search.school.length > 0) {
        projects = projects.filter((p) => {
          let owners = data.participants[p.id] || [];
          return owners.some((owner) => search.school.includes(+owner.SchoolId));
        });
      }
      if (search.entryType && search.entryType.length > 0) {
        projects = projects.filter((p) => search.entryType.includes(p.entryTypeId));
      }

      if (search.text && search.text.length > 0) {
        console.log('search text', search.text);
        projects = projects.filter((p) => {
          let owners = data.participants[p.id] || [];
          for (let txt of search.text!) {
            //for(let i = 0; i < search.text.length; i++) {
            //let txt = search.text[i];
            if (p.title.toLowerCase().includes(txt)) return true;
            if (p.projectId.toString().includes(txt)) return true;
            if (owners.some((owner) => owner.FirstName.toLowerCase().includes(txt) || owner.LastName.toLowerCase().includes(txt))) return true;
          }
          return false;
        });
      }

      setFilteredEntries(projects);
    }
  }, [data, search]);

  const init = () => {
    store.server.getApi<ServerResponse<IFeeTrackingData>>('FeeTracking/data').then((x) => {
      if (x.Success) {
        setData(x.Value);
      }
    });
  };

  const MakeInvoice = (entryId, participantId) => {
    window.open(StoreX.BuildUrl(`../FeeTracking/Invoice?entryId=${entryId}&participantId=${participantId}`), '_blank');

    //listen to refresh if the other page tells me too...
  };

  const map = () => {
    if (data) {
      if (data.feeByProject) {
        return mapByProject();
      } else {
        return mapByParticipant();
      }
    } else {
      return <p>Loading...</p>;
    }
  };

  const mapByProject = () => {
    return (
      <>
        {filteredEntries.length > 0 &&
          filteredEntries.map((entry, index) => {
            let owners = data.participants[entry.id] || [];
            let fees = data.fees[entry.id] || [];
            let invoice = invoicesByEntry[entry.id] || [];
            let feeSummary = data.feeInfoDic[entry.id];

            return (
              <div key={index} className="list-item">
                <div className="">
                  <div className="flex-between">
                    <div>
                      <h3>{entry.projectId}</h3>
                    </div>
                    <div>
                      {feeSummary?.PaidInFull && (
                        <h3>
                          <span className="label label-success">
                            <Icon type={IconType.done} /> Paid In Full{' '}
                          </span>
                        </h3>
                      )}
                    </div>
                  </div>
                  <div>
                    <strong>Title: </strong>
                    <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(entry.title) }}></div>
                  </div>
                </div>
                <div>
                  <h4>Participants</h4>
                  <div className="flex owner-list">
                    {owners &&
                      owners.map((owner, idx) => (
                        <div key={idx} className="owner-info">
                          {owner.FirstName} {owner.LastName}
                          {owner.Email && <div>{owner.Email}</div>}
                          {owner.School && <div>{owner.School}</div>}
                          {feeSummary && !feeSummary.PaidInFull && (
                            <button type="button" className="text-info" onClick={() => MakeInvoice(entry.id, owner.PersonId)}>
                              <Icon type={IconType.payNow} /> Process Payment
                            </button>
                          )}
                        </div>
                      ))}
                  </div>
                </div>

                <h4>Fee Info </h4>

                <div className="flex invoice-list">
                  {fees &&
                    fees.map((inv, idx) => (
                      <div key={idx} className="invoice-info">
                        {inv.paidInFull && (
                          <h4 className="text-success">
                            <Icon type={IconType.done} /> Paid In Full
                          </h4>
                        )}
                        <div>
                          Invoice:{' '}
                          <a href={StoreX.BuildUrlWithFair(`/purchase/GetInvoiceFromId/${inv.OrderId}`)} target="_blank" title="View Invoice">
                            {inv.OrderId}
                          </a>
                        </div>
                        <div>Amount: {FormatMoney(inv.amountPaid)}</div>
                        {inv.paidWhen && <div>Paid: {FormatDate(inv.paidWhen)}</div>}
                        {inv.notes && <div>Notes: {inv.notes}</div>}
                      </div>
                    ))}
                  {feeSummary && !feeSummary.PaidInFull && (
                    <div className="invoice-info">
                      <h4 className="text-danger">Fee Required</h4>
                      <div>Total Fee: {FormatMoney(feeSummary.AmountRequired)}</div>
                      {feeSummary.LateFeeRequired && <div>Late Fee: {FormatMoney(feeSummary.LateFee)}</div>}
                      <div>Balance Due: {FormatMoney(feeSummary.AmountRequired)}</div>
                    </div>
                  )}
                </div>

                {invoice && invoice.length > 0 && <h4>Invoices</h4>}
                {/* Entry Invoices... */}
                <div className="flex invoice-list">
                  {invoice &&
                    invoice.map((inv, idx) => (
                      <div key={idx} className="invoice-info">
                        {inv.Paid ? (
                          <h4 className="text-success">
                            <Icon type={IconType.done} /> Invoice Paid
                          </h4>
                        ) : (
                          <h4 className="text-warning">
                            <Icon type={IconType.payNow} /> Payment Pending
                          </h4>
                        )}
                        <div>
                          Invoice:{' '}
                          <a href={StoreX.BuildUrlWithFair(`/purchase/GetInvoiceFromId/${inv.OrderId}`)} target="_blank" title="View Invoice">
                            {inv.OrderId}
                          </a>
                        </div>
                        <div>Amount: {FormatMoney(inv.Total)}</div>
                        {inv.PaidOnUtc && <div>Paid: {FormatDate(inv.PaidOnUtc)}</div>}
                        {inv.Paid && (
                          <span className="label label-success">
                            <Icon type={IconType.done} /> Paid
                          </span>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            );
          })}
      </>
    );
  };

  const mapByParticipant = () => {
    return (
      <>
        {filteredEntries.length > 0 &&
          filteredEntries.map((entry, index) => {
            let owners = data.participants[entry.id] || [];
            let invoice = invoicesByEntry[entry.id] || [];
            return (
              <div key={index} className="list-item">
                <div className="">
                  <div className="flex-between">
                    <div>
                      <h3>{entry.projectId}</h3>
                    </div>
                    <div></div>
                  </div>
                  <div>
                    <strong>Title: </strong>
                    <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(entry.title) }}></div>
                  </div>
                </div>
                <div>
                  <h4>Participants</h4>
                  <div className="flex owner-list">
                    {owners &&
                      owners.map((owner, idx) => {
                        let feeSummary = data.feeInfoDic[owner.PersonId+"|"+entry.id];
                        return (
                          <div key={idx} className="owner-info">
                            {owner.FirstName} {owner.LastName}
                            {owner.Email && <div>{owner.Email}</div>}
                            {owner.School && <div>{owner.School}</div>}
                            {feeSummary && !feeSummary.PaidInFull && (
                              <button type="button" className="text-info" onClick={() => MakeInvoice(entry.id, owner.PersonId)}>
                                <Icon type={IconType.payNow} /> Process Payment
                              </button>
                            )}
                            {feeSummary?.PaidInFull && (
                              <div>
                                <span className="label label-success">
                                  <Icon type={IconType.done} /> Paid In Full{' '}
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>

                {invoice && invoice.length > 0 && <h4>Invoices</h4>}
                {/* Entry Invoices... */}
                <div className="flex invoice-list">
                  {invoice &&
                    invoice.map((inv, idx) => {
                      return (
                        <div key={idx} className="invoice-info">
                          {inv.Paid ? (
                            <h4 className="text-success">
                              <Icon type={IconType.done} /> Invoice Paid
                            </h4>
                          ) : (
                            <h4 className="text-warning">
                              <Icon type={IconType.payNow} /> Payment Pending
                            </h4>
                          )}
                          <div>
                            Invoice:{' '}
                            <a href={StoreX.BuildUrlWithFair(`/purchase/GetInvoiceFromId/${inv.OrderId}`)} target="_blank" title="View Invoice">
                              {inv.OrderId}
                            </a>
                          </div>
                          <div>Amount: {FormatMoney(inv.Total)}</div>
                          {inv.PaidOnUtc && <div>Paid: {FormatDate(inv.PaidOnUtc)}</div>}
                          {inv.Paid && (
                            <span className="label label-success">
                              <Icon type={IconType.done} /> Paid
                            </span>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <div className="flex-between">
        <h3>Entry Fee Tracking by {data && data.feeByProject ? 'Project' : 'Participant'}</h3>
        {data && (
          <p>
            {filteredEntries.length} of {data.projects.length}
          </p>
        )}
        <div>
          <Button type="refresh" onClick={init} />
        </div>
      </div>
      <div className="form-horizontal">
        <div className="form-group">
          <label className="control-label col-sm-3">Search</label>
          <div className="col-sm-9">
            <Creatable
              isClearable
              isMulti
              placeholder="Search by: Name, Entry, Title, School, Category, etc..."
              autoFocus={true}
              options={searchablePoints}
              onChange={(selected) => {
                const newSearch: ISearch = { category: [], school: [], entryType: [], text: [] };
                selected.forEach((item) => {
                  const [type, id] = (item.value + '').split('|');
                  if (type === 'paid') newSearch.paid = true;
                  else if (type === 'notPaid') newSearch.notPaid = true;
                  else if (type === 'team') newSearch.team = true;
                  else if (type === 'noInvoice') newSearch.noInvoice = true;
                  else if (type === 'category') newSearch.category.push(+id);
                  else if (type === 'school') newSearch.school.push(+id);
                  else if (type === 'entryType') newSearch.entryType.push(+id);
                  else newSearch.text.push(type.trim().toLowerCase());
                });
                setSearch(newSearch);
              }}
            />
          </div>
        </div>
      </div>

      <div className="list-container fee-tracking">{map()}</div>
    </>
  );
};

export default FeeTracking;
